var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("header", [_c("core-app-bar")], 1),
      _vm._v(" "),
      _c(
        "main",
        { attrs: { role: "main" } },
        [
          _c("core-view"),
          _vm._v(" "),
          _c("footer", { staticClass: "footer-modern" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container footer-container" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "footer-col",
                        attrs: { lg: "4", md: "6", sm: "12", xl: "4" },
                      },
                      [
                        _c("div", { staticClass: "footer-card" }, [
                          _c("div", { staticClass: "footer-logo" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.app_logo,
                                alt: "Sitrendi Logo",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "footer-description" }, [
                            _vm._v(
                              "\n                SiTrendi (Sistem Pesantren Digital) adalah layanan Aplikasi Digital yang\n                memberikan solusi inovatif dalam hal pelayanan sistem transaksi keuangan digital,\n                pencatatan dan laporan keuangan yang dapat terintegrasi dengan layanan sistem\n                digital lainnya, seperti School Management System, Multi Biller Digital, dan\n                lainnya\n              "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "footer-col",
                        attrs: { lg: "4", md: "6", sm: "12", xl: "4" },
                      },
                      [
                        _c("div", { staticClass: "footer-card" }, [
                          _c("h3", { staticClass: "footer-title" }, [
                            _c("i", { staticClass: "fa fa-link" }),
                            _vm._v(" Sitrendi"),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "footer-links" }, [
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/page/kontak-kami" } },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                    }),
                                    _vm._v(" Kontak Kami\n                  "),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/page/tentang-kami" } },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                    }),
                                    _vm._v(" Tentang Kami\n                  "),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/page/peta-situs" } },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                    }),
                                    _vm._v(" Peta Situs\n                  "),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/page/privacy-policy" } },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                    }),
                                    _vm._v(
                                      " Privacy & Policy\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/daftar-implementasi-pesantren",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                    }),
                                    _vm._v(
                                      " Daftar Implementasi Pesantren\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: "/page/cek-status-booking" } },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                    }),
                                    _vm._v(
                                      " Cek Status Booking Implementasi\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "footer-col",
                        attrs: { lg: "4", md: "6", sm: "12", xl: "4" },
                      },
                      [
                        _c("div", { staticClass: "footer-card" }, [
                          _c("h3", { staticClass: "footer-title" }, [
                            _c("i", { staticClass: "fa fa-phone-alt" }),
                            _vm._v(" Hubungi Kami"),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "footer-contact" }, [
                            _c("li", [
                              _c("div", { staticClass: "contact-item" }, [
                                _c("i", {
                                  staticClass: "fa fa-map-marker-alt",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "contact-text" }, [
                                  _vm._v(
                                    "\n                      KJS MARI Jl. Panjang No.6C"
                                  ),
                                  _c("br"),
                                  _vm._v("Kedoya Utara, Kebon Jeruk"),
                                  _c("br"),
                                  _vm._v("Jakarta Barat\n                    "),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "contact-link",
                                  attrs: {
                                    href: "https://wa.me/6281564619990",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-phone" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("+62 815-6461-9990")]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "contact-link",
                                  attrs: {
                                    href: "mailto:kontak@sitrendi.id",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-envelope" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("kontak@sitrendi.id")]),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("core-footer"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-background" }, [
      _c("div", { staticClass: "footer-decoration" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }